export const createAuthSlice = (set) => ({
  user: null,
  role: 'guest',
  isAuthenticated: false,
  token: null,

  login: (user, role, token) => set({ user, role, isAuthenticated: true, token }),
  logout: () => set({ user: null, role: 'guest', isAuthenticated: false, token: null })
});
